import { render, staticRenderFns } from "./AdminMisc.vue?vue&type=template&id=8a79ff1c"
import script from "./AdminMisc.vue?vue&type=script&lang=js"
export * from "./AdminMisc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports